module.exports = __webpack_public_path__ + "media/images/athletes/2804-b759698fb17cd539d2180a4c87ea161a.png";